<template>
  <div class="container-fluid">
    <div class="row justify-content-md-center">
      <div class="col-md-9 col-xl-9">
        <div class="card-header px-0 mt-2 bg-transparent clearfix">
          <h4 class="float-left pt-2">Request a quotation</h4>
          <div class="card-header-actions mr-1">
            <a dusk="save-button" class="btn btn-primary" href="#" :disabled="submiting" @click.prevent="create">
              <i class="fas fa-spinner fa-spin" v-if="submiting"></i>
              <i class="fas fa-check" v-else></i>
              <span class="ml-1">Request quotation</span>
            </a>
          </div>
        </div>
        <div class="card-body px-0">
          <div class="form-group">
              <label>You are requesting a quotation for:</label>
              <input class="form-control" type="text" v-model="configname" readonly>
            </div>
          <div class="form-group">
            <label>Quantity for Quotation</label>
            <input dusk="name-input" type="text" class="form-control" :class="{'is-invalid': errors.qta}" v-model="user.qta">
            <div class="invalid-feedback" v-if="errors.qta">{{errors.qta[0]}}</div>
          </div>
          <div class="form-group">
            <label>Requested Delivery Time</label>
            <input type="text" class="form-control" :class="{'is-invalid': errors.time}" v-model="user.time">
            <div class="invalid-feedback" v-if="errors.time">{{errors.time[0]}}</div>
          </div>
          <div class="form-group">
            <input dusk="agree-input" style="display:inline; width:auto; height: auto;" class="form-control" type="checkbox" :class="{'is-invalid': errors.agree}" v-model="user.agree" /> by clicking "<b>Request quotation</b>" you are agreeing to the terms of use and acknowledging the privacy policy
            <div class="invalid-feedback" v-if="errors.agree">{{errors.agree[0]}}</div>
          </div>
          <div class="form-group">
            <label>Further Requests and Notes</label>
            <textarea rows="10" dusk="note-input" class="form-control" :class="{'is-invalid': errors.note}" v-model="user.note"></textarea>
            <div class="invalid-feedback" v-if="errors.note">{{errors.note[0]}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: {},
      errors: {},
      submiting: false
    }
  },
  props: {
      configname:{
          type: String,
          default: ""
      },
      configid:{
          type: String,
          default: null
      }
  },
  mounted () {

  },
  methods: {
    isUser(roles){
      return roles.find(function(el){
         return el.id === 2
      }) != null;
    },
    create () {
      if (!this.submiting) {
        this.submiting   = true
        this.user.config = {
          name: this.configname,
          id  : this.configid
        }
        axios.post(`/api/drawer/send_request`, this.user)
        .then(response => {
          this.$toasted.global.error(this.$i18n.t('users.created'))
          this.$swal({
              title             : 'The quote request has been sent!',
              text              : "Thanks to having chosen UmbraGroup",
              type              : 'success',
              showCancelButton  : false,
              confirmButtonColor: '#3085d6',
              confirmButtonText : 'Proceed!'
          }).then((result) => {
              location.href = '/drawer/list'
          });
        })
        .catch(error => {
          this.errors    = error.response.data.errors
          this.submiting = false;
          if (error.response.status == 400){
            this.$swal({
                title             : 'Error during request!',
                html              : 'Please contact us at email: <a href="industrial@umbragroup.com">industrial@umbragroup.com</a>',
                type              : 'error',
                showCancelButton  : false,
                confirmButtonColor: '#3085d6',
                confirmButtonText : 'Proceed!'
            });
          }
        })
      }
    }
  }
}
</script>
